export const bloom = {
  hidden: { scale: 0.85, opacity: 0, filter: 'blur(6px)' },
  visible: (i = 0) => ({
    scale: 1, opacity: 1, filter: 'blur(0px)',
    transition: { type: 'spring', stiffness: 70, damping: 14, delay: i * 0.1 },
  }),
};

export const sacredRise = {
  hidden: { y: 50, opacity: 0 },
  visible: (i = 0) => ({
    y: 0, opacity: 1,
    transition: { duration: 0.9, delay: i * 0.1, ease: [0.25, 0.46, 0.45, 0.94] },
  }),
};

export const minaretReveal = {
  hidden: { scaleY: 0, originY: 'bottom' },
  visible: (i = 0) => ({
    scaleY: 1,
    transition: { duration: 0.8, delay: i * 0.1, ease: [0.76, 0, 0.24, 1] },
  }),
};

export const goldLine = {
  hidden: { scaleX: 0, originX: 0 },
  visible: { scaleX: 1, transition: { duration: 1.2, ease: [0.76, 0, 0.24, 1] } },
};

export const fadeSacred = {
  hidden: { opacity: 0 },
  visible: (i = 0) => ({
    opacity: 1,
    transition: { duration: 0.8, delay: i * 0.12, ease: [0.4, 0, 0.2, 1] },
  }),
};

export const stagger = (d = 0.08) => ({
  hidden: {},
  visible: { transition: { staggerChildren: d } },
});

export const imageReveal = {
  hidden: { scale: 1.08, opacity: 0 },
  visible: {
    scale: 1, opacity: 1,
    transition: { duration: 1.1, ease: [0.25, 0.46, 0.45, 0.94] },
  },
};

export const staggerPremium = (d = 0.12) => ({
  hidden: {},
  visible: { transition: { staggerChildren: d, delayChildren: 0.1 } },
});

export const luxuriousFloat = {
  hidden: { y: 30, opacity: 0, scale: 0.95 },
  visible: (i = 0) => ({
    y: 0, opacity: 1, scale: 1,
    transition: { duration: 1.2, delay: i * 0.15, ease: [0.25, 0.46, 0.45, 0.94] },
  }),
};

export const shimmerReveal = {
  hidden: { opacity: 0, filter: 'blur(12px)', scale: 0.9 },
  visible: (i = 0) => ({
    opacity: 1, filter: 'blur(0px)', scale: 1,
    transition: { duration: 1.2, delay: i * 0.12, ease: [0.34, 1.56, 0.64, 1] },
  }),
};

export const premiumCardReveal = {
  hidden: { opacity: 0, y: 40, scale: 0.95 },
  visible: (i = 0) => ({
    opacity: 1, y: 0, scale: 1,
    transition: { duration: 1.0, delay: i * 0.1, ease: [0.25, 0.46, 0.45, 0.94] },
  }),
};

export const auroraGlow = {
  hidden: { opacity: 0, scale: 0.8 },
  visible: { opacity: 1, scale: 1, transition: { duration: 1.8, ease: "easeOut" } },
};

